const global = window

// Remplissage automatique
inputs.behavior.request = function (data, name, niceName, type, input, parent, inputWindow) {
    const apiForm = input.closest('[data-api]')
    const apiFormData = apiForm.data('data')

    if (data.request) {
        input.click(function(event) {
            if (!input.data('hold') && apiForm) {
                const url = apiForm.data('api');
                if (!url) {
                    console.error('No API URL provided')
                    return false
                }
                const reqData = (typeof data.request.data !== 'undefined') ? data.request.data : getFormData(apiForm, true);
                callAPI((data.request.method) ? data.request.method : 'PUT', url, reqData, function () {
                    if (event.type === 'click') {
                        if (parent && parent.closeWindow) parent.closeWindow();
                        if (data.request.method == 'DELETE' || data.request.remove) {
                            const table = apiForm.closest('table');
                            apiForm.remove();
                            if (table.length) {
                                table.trigger('row:reloaded');
                            }
                        }
                        else if (apiFormData && apiFormData.ajax) {
                            apiFormData.reload();
                        }
                    }
                });
            }
        })
    }
    return data
}
